import axios, { AxiosInstance } from 'axios';

import useRequestInterceptors from './interceptors/request';
import useResponseInterceptors from './interceptors/response';

export class HttpClient {
  public instance: AxiosInstance;

  constructor(api_url?: string) {
    this.instance = axios.create();
    if (!api_url) {
      this.instance.defaults.baseURL = process.env.VUE_APP_API_URL;
    } else {
      this.instance.defaults.baseURL = api_url;
    }

    useRequestInterceptors(this);
    useResponseInterceptors(this);
  }
}

export default function httpClient(api_url?: string): HttpClient {
  return new HttpClient(api_url);
}
